const styles = {
    datePickertextField: {
        '&.MuiFormControl-root': {
            '& .MuiInputBase-root': {
                maxWidth: '85px',
                cursor: 'pointer',
                paddingRight: 0,

                '& .MuiInputBase-input': {
                    fontSize: '12px',
                    padding: 0,
                    width: '60px',
                },
                '& .MuiInputAdornment-root': {
                    marginLeft: 0,
                },
                '& ::placeholder': {
                    color: 'white',
                    opacity: 0,
                },
                '& fieldset': {
                    display: 'none',
                },
            },
        },
    },
    customTable: {
        '&.MuiPaper-root': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },

        '& thead tr': {
            backgroundColor: '#0063a7',

            '& th': {
                color: 'white',
                padding: '10px 15px',
            },
        },
        '& tbody tr': {
            '& th, td': {
                padding: '10px 15px',
                fontWeight: 500,
            },
        },
    },
    commentBox: {
        '&.MuiBox-root': {
            boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
            borderBottomLeftRadius: '4px',
            borderBottomRightRadius: '4px',
            padding: '20px 15px',
        },
    },
    commentHeader: {
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 500,
        backgroundColor: '#0063a7',
        color: 'white',
        padding: '0 15px',
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    commentTextarea: {
        '& .MuiOutlinedInput-root': {
            padding: '2px 12px 12px',
        },

        '& fieldset legend': {
            display: 'none',
        },
    },
    smLabelRadioBtn: {
        '&.MuiFormControlLabel-root': {
            marginLeft: 0,

            '& .MuiTypography-root': {
                fontSize: '14px',
                color: 'black',
                marginLeft: '4px',
            },
        },
    },
};

export default styles;
